module.exports = __webpack_public_path__ + "static/img/1_13.c94ada4b.jpg";